// src/api/redlining.js - Fixed to match backend routes
import axios from 'axios';
import { API_URL } from '../utils/apiConfig';

// Create API instance
const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || 
               (localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).token : null);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for better error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Get all annotations for a document
export const getAnnotations = async (documentId) => {
  try {
    return await api.get(`/annotations/document/${documentId}`);
  } catch (error) {
    console.error('Error fetching annotations:', error);
    throw error;
  }
};

// Create a new annotation
export const createAnnotation = async (documentId, annotationData) => {
  try {
    return await api.post(
      `/annotations/documents/${documentId}/annotations`,
      annotationData
    );
  } catch (error) {
    console.error('Error creating annotation:', error);
    throw error;
  }
};

// Update an annotation
export const updateAnnotation = async (annotationId, updates) => {
  try {
    return await api.put(`/annotations/${annotationId}`, updates);
  } catch (error) {
    console.error('Error updating annotation:', error);
    throw error;
  }
};

// Delete an annotation
export const deleteAnnotation = async (annotationId) => {
  try {
    return await api.delete(`/annotations/${annotationId}`);
  } catch (error) {
    console.error('Error deleting annotation:', error);
    throw error;
  }
};

// AI analyze document and create suggested annotations (general analysis)
export const analyzeDocumentWithAI = async (documentId) => {
  try {
    return await api.post(`/annotations/documents/${documentId}/analyze`);
  } catch (error) {
    console.error('Error analyzing document with AI:', error);
    throw error;
  }
};

// Analyze contract clauses specifically
export const analyzeContractClauses = async (documentId) => {
  try {
    return await api.post(`/annotations/analyze-clauses/${documentId}`);
  } catch (error) {
    console.error('Error analyzing contract clauses:', error);
    throw error;
  }
};

// Get AI suggestions for a comment
export const getAISuggestion = async (documentId, context) => {
  try {
    return await api.post(`/annotations/documents/${documentId}/ai-suggestion`, context);
  } catch (error) {
    console.error('Error getting AI suggestion:', error);
    throw error;
  }
};

// Generate a summary of all document annotations
export const generateCommentSummary = async (documentId) => {
  try {
    return await api.get(`/annotations/documents/${documentId}/summary`);
  } catch (error) {
    console.error('Error generating comment summary:', error);
    throw error;
  }
};

export default {
  getAnnotations,
  createAnnotation,
  updateAnnotation,
  deleteAnnotation,
  analyzeDocumentWithAI,
  analyzeContractClauses,
  getAISuggestion,
  generateCommentSummary
};